export const MODULE_PERMISSION_TYPE = 'MODULE_PERMISSION';
export const FIELD_PERMISSION_TYPE = 'FIELD_PERMISSION';

export const DASHBOARD_MODULE_PERMISSION_CODE = 'DASHBOARD';
export const PROCESSOS_MODULE_PERMISSION_CODE = 'PROCESSOS';
export const REPORTS_MODULE_PERMISSION_CODE = 'RELATORIOS';
export const CALENDARIO_FINANCEIRO_MODULE_PERMISSION_CODE = 'CALENDARIO_FINANCEIRO';
export const CALENDARIO_OPERACIONAL_MODULE_PERMISSION_CODE = 'CALENDARIO_OPERACIONAL';
export const ANALYTICS_MODULE_PERMISSION_CODE = 'ANALYTICS';

export const ROUTE_MODULE_PERMISSION = {
  Home: DASHBOARD_MODULE_PERMISSION_CODE,
  Processes: PROCESSOS_MODULE_PERMISSION_CODE,
  ProcessesReport: REPORTS_MODULE_PERMISSION_CODE,
  FinanceiroPrevisaoNumerario: CALENDARIO_FINANCEIRO_MODULE_PERMISSION_CODE,
  FinanceiroPrevisaoNumerarioNovo: CALENDARIO_FINANCEIRO_MODULE_PERMISSION_CODE,
  OperacionalCalendario: CALENDARIO_OPERACIONAL_MODULE_PERMISSION_CODE,
  Analytics: ANALYTICS_MODULE_PERMISSION_CODE,
};
